import React, { useEffect, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';
import PointOfSaleRoundedIcon from '@mui/icons-material/PointOfSaleRounded';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import ExposureRoundedIcon from '@mui/icons-material/ExposureRounded';
import './BottomNav.scss';

interface BottomNavType {
    active: number;
    selectedRestId: any;
    roles: any;
}

type NavItem = {
    key: string;
    label: string;
    index: number;
    icon: React.ReactNode;
    visible?: boolean;
};

const BottomNav = ({ active, selectedRestId, roles }: BottomNavType) => {
    const navigate = useNavigate();
    const param = useParams();
    const [value, setValue] = React.useState(active ?? 0);

    const showInventory = roles && selectedRestId && ['admin', 'manager'].includes(roles[selectedRestId]?.role);

    const navItems = useMemo<NavItem[]>(() => [
        { key: 'orders', label: 'Orders', index: 0, icon: <HomeRoundedIcon /> },
        { key: 'rooms', label: 'Rooms', index: 1, icon: <ReceiptLongRoundedIcon /> },
        { key: 'pos', label: 'POS', index: 2, icon: <PointOfSaleRoundedIcon /> },
        { key: 'khaata', label: 'Khaata', index: 3, icon: <ExposureRoundedIcon /> },
        { key: 'inventory', label: 'Inventory', index: 4, icon: <InventoryRoundedIcon />, visible: showInventory },
    ], [showInventory]);

    const visibleItems = navItems.filter((item) => item.visible !== false);

    useEffect(() => {
        setValue(active ?? 0);
    }, [active]);

    const handleSetValue = (newValue: number) => {
        setValue(newValue);
        const restaurantId = param?.restaurantId;
        switch (newValue) {
            case 0:
                navigate(`/admin/${restaurantId}/orders`);
                break;
            case 1:
                navigate(`/admin/${restaurantId}/room-billing`);
                break;
            case 2:
                navigate(`/admin/${restaurantId}/pos`);
                break;
            case 3:
                navigate(`/admin/${restaurantId}/khaata`);
                break;
            case 4:
                navigate(`/admin/${restaurantId}/inventory`);
                break;
            default:
                break;
        }
    };

    return (
        <nav className="bottom-nav mobBlock" aria-label="Admin navigation">
            <div className="bottom-nav__inner">
                {visibleItems.map((item) => {
                    const isActive = value === item.index;
                    return (
                        <button
                            key={item.key}
                            type="button"
                            className={`bottom-nav__item ${isActive ? 'bottom-nav__item--active' : ''}`}
                            onClick={() => handleSetValue(item.index)}
                            aria-current={isActive ? 'page' : undefined}
                        >
                            <span className="bottom-nav__icon">{item.icon}</span>
                            <span className="bottom-nav__label">{item.label}</span>
                        </button>
                    );
                })}
            </div>
        </nav>
    );
};

const mapStateToProps = (state: any) => {
    const { user, common } = state;
    return {
        selectedRestId: common?.selectedRestaurant?.docId || '',
        roles: user?.user?.roles || {},
    };
};

export default connect(mapStateToProps)(BottomNav);
